/*import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeDepoimentos = () => {
  const depoimentosSection = document.getElementById("depoimentos-home");
  if (!depoimentosSection) return;

  let slidesPorGrupo = 3; // Inicialmente no desktop (3 slides por vez)
  let totalSlides = depoimentosSection.querySelectorAll(".mySwiperDepoimentos .swiper-slide").length;
  let totalGrupos = Math.ceil(totalSlides / slidesPorGrupo);
  const duracao = 8000;

  // Função para criar as barras de progresso dinamicamente
  function criarBarras() {
    const container = depoimentosSection.querySelector(".swiper-progress-depo-nucleon");
    if (!container) return;

    container.innerHTML = ""; // Limpa barras antigas

    for (let i = 0; i < totalGrupos; i++) {
      const barra = document.createElement("div");
      barra.classList.add("barra", "w-[298px]", "h-[2px]", "bg-white/20", "rounded-[8px]", "relative", "overflow-hidden", "cursor-pointer");
      barra.setAttribute("data-slide", i);

      const fill = document.createElement("div");
      fill.classList.add("fill", "absolute", "top-0", "left-0", "h-full", "bg-gradient-to-r", "from-[#9c7b3a]", "to-[#ccab78]", "rounded-[8px]");
      fill.style.width = "0px";

      barra.appendChild(fill);
      container.appendChild(barra);

      // Clique na barra para navegar
      barra.addEventListener("click", () => {
        clearInterval(progressoTimer);
        mostrarGrupo(i);
      });
    }
  }

  // Instanciando o swiper
  const swiper = new Swiper(".mySwiperDepoimentos", {
    slidesPerView: slidesPorGrupo,
    slidesPerGroup: 1,
    spaceBetween: 32,
    loop: false,
    allowTouchMove: true,
    navigation: {
      nextEl: ".swiper-depoimentos-next",
      prevEl: ".swiper-depoimentos-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 1,
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
    },
    watchOverflow: true,
  });

  let grupoAtual = 0;
  let progressoTimer = null;

  // Atualiza totalGrupos e cria as barras conforme slidesPorGrupo e totalSlides
  function atualizarGruposEBarras() {
    slidesPorGrupo = swiper.params.slidesPerView;
    totalSlides = depoimentosSection.querySelectorAll(".mySwiperDepoimentos .swiper-slide").length;
    totalGrupos = Math.ceil(totalSlides / slidesPorGrupo);
    criarBarras();
  }

  const barraFills = () => depoimentosSection.querySelectorAll(".swiper-progress-depo-nucleon .fill");
  const grupoAtualElem = depoimentosSection.querySelector("#grupo-atual");
  const grupoTotalElem = depoimentosSection.querySelector("#grupo-total");

  // Resetar barras
  function resetarBarras() {
    barraFills().forEach((fill) => {
      fill.style.width = "0px";
    });
  }

  // Iniciar barra de progresso do grupo atual
  function iniciarBarra(grupoIndex) {
    resetarBarras();

    const fills = barraFills();
    if (!fills[grupoIndex]) return; // Proteção contra índices inválidos

    const barraAtual = fills[grupoIndex];
    let largura = 0;
    const larguraMax = 298; // largura da barra em px
    const incremento = larguraMax / (duracao / 50);

    clearInterval(progressoTimer);
    progressoTimer = setInterval(() => {
      largura += incremento;
      if (largura >= larguraMax) {
        barraAtual.style.width = `${larguraMax}px`;
        clearInterval(progressoTimer);

        grupoAtual = (grupoAtual + 1) % totalGrupos;
        mostrarGrupo(grupoAtual);
      } else {
        barraAtual.style.width = `${largura}px`;
      }
    }, 50);
  }

  // Atualizar a numeração (slide atual / total)
  function atualizarNumeracao() {
    if (!grupoAtualElem || !grupoTotalElem) return;

    grupoAtualElem.textContent = String(grupoAtual + 1).padStart(2, "0");

    if (window.innerWidth < 1024) {
      // Em telas menores, mostrar slide atual / totalSlides
      grupoTotalElem.textContent = String(totalSlides).padStart(2, "0");
    } else {
      // Em telas grandes, mostrar grupo atual / totalGrupos
      grupoTotalElem.textContent = String(totalGrupos).padStart(2, "0");
    }
  }

  // Mostrar grupo atual (slide)
  function mostrarGrupo(index) {
    grupoAtual = index;

    if (grupoAtual >= totalGrupos) {
      grupoAtual = 0;
    }

    swiper.slideTo(grupoAtual * slidesPorGrupo, 600);
    atualizarNumeracao();
    iniciarBarra(grupoAtual);
  }

  // Botões navegação
  const botaoProximo = depoimentosSection.querySelector(".swiper-depoimentos-next");
  if (botaoProximo) {
    botaoProximo.addEventListener("click", () => {
      clearInterval(progressoTimer);
      mostrarGrupo(grupoAtual >= totalGrupos - 1 ? 0 : grupoAtual + 1);
    });
  }

  const botaoAnterior = depoimentosSection.querySelector(".swiper-depoimentos-prev");
  if (botaoAnterior) {
    botaoAnterior.addEventListener("click", () => {
      clearInterval(progressoTimer);
      mostrarGrupo(grupoAtual > 0 ? grupoAtual - 1 : totalGrupos - 1);
    });
  }

  // Atualizar grupos e barras ao mudar breakpoint
  swiper.on('breakpoint', () => {
    atualizarGruposEBarras();
    mostrarGrupo(0);
  });

  // Atualizar numeração ao redimensionar tela
  window.addEventListener("resize", () => {
    atualizarNumeracao();
  });

  // Inicialização
  atualizarGruposEBarras();
  mostrarGrupo(0);
};

export default initializeDepoimentos;


*/

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeDepoimentos = () => {
  const depoimentosSection = document.getElementById("depoimentos-home");
  if (!depoimentosSection) return;

  let slidesPorGrupo = 3;
  let totalSlides = depoimentosSection.querySelectorAll(".mySwiperDepoimentos .swiper-slide").length;
  const duracao = 8000;

  const swiper = new Swiper(".mySwiperDepoimentos", {
    slidesPerView: slidesPorGrupo,
    slidesPerGroup: 1,
    spaceBetween: 32,
    loop: false,
    allowTouchMove: true,
    navigation: {
      nextEl: ".swiper-depoimentos-next",
      prevEl: ".swiper-depoimentos-prev",
    },
    breakpoints: {
      0: { slidesPerView: 1, slidesPerGroup: 1 },
      768: { slidesPerView: 2, slidesPerGroup: 1 },
      1024: { slidesPerView: 3, slidesPerGroup: 1 },
    },
    watchOverflow: true,
  });

  let grupoAtual = 0;
  let progressoTimer = null;

  const progressContainer = depoimentosSection.querySelector(".swiper-progress-depo-nucleon");

  function getTotalGrupos() {
    return Math.ceil(totalSlides / slidesPorGrupo);
  }

  function criarBarras() {
    if (!progressContainer) return;

    progressContainer.innerHTML = ""; // Limpa as barras anteriores
    const totalGrupos = getTotalGrupos();

    for (let i = 0; i < totalGrupos; i++) {
      const barra = document.createElement("div");
      barra.setAttribute("data-slide", i);

      // Estilo da barra inativa
      Object.assign(barra.style, {
        width: "298px",
        height: "8px",
        background: "rgba(255, 255, 255, 0.20)",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        marginRight: "8px", // espaçamento entre barras
        display: "inline-block",
      });

      const fill = document.createElement("div");

      // Estilo da barra preenchida (ativa)
      Object.assign(fill.style, {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "0px",
        background: "linear-gradient(to right, #9c7b3a, #ccab78)",
        borderRadius: "8px",
        transition: "width 0.05s linear",
      });

      barra.appendChild(fill);
      progressContainer.appendChild(barra);

      barra.addEventListener("click", () => {
        clearInterval(progressoTimer);
        mostrarGrupo(i);
      });
    }
  }

  function barraFills() {
    return depoimentosSection.querySelectorAll(".swiper-progress-depo-nucleon div div");
  }

  function atualizarNumeracao() {
    const atualEl = depoimentosSection.querySelector("#grupo-atual");
    const totalEl = depoimentosSection.querySelector("#grupo-total");

    if (atualEl && totalEl) {
      atualEl.textContent = String(grupoAtual + 1).padStart(2, "0");
      totalEl.textContent = String(getTotalGrupos()).padStart(2, "0");
    }
  }

  function resetarBarras() {
    barraFills().forEach((fill) => {
      fill.style.width = "0px";
    });
  }

  function iniciarBarra(grupoIndex) {
    resetarBarras();

    const fills = barraFills();
    const barraAtual = fills[grupoIndex % fills.length];
    if (!barraAtual) return;

    let largura = 0;
    const incremento = 298 / (duracao / 50);

    clearInterval(progressoTimer);
    progressoTimer = setInterval(() => {
      largura += incremento;
      if (largura >= 298) {
        barraAtual.style.width = "298px";
        clearInterval(progressoTimer);
        grupoAtual = (grupoAtual + 1) % getTotalGrupos();
        mostrarGrupo(grupoAtual);
      } else {
        barraAtual.style.width = `${largura}px`;
      }
    }, 50);
  }

  function mostrarGrupo(index) {
    grupoAtual = index;
    swiper.slideTo(grupoAtual * slidesPorGrupo, 600);
    atualizarNumeracao();
    iniciarBarra(grupoAtual);
  }

  const botaoProximo = depoimentosSection.querySelector(".swiper-depoimentos-next");
  if (botaoProximo) {
    botaoProximo.addEventListener("click", () => {
      clearInterval(progressoTimer);
      mostrarGrupo(grupoAtual >= getTotalGrupos() - 1 ? 0 : grupoAtual + 1);
    });
  }

  const botaoAnterior = depoimentosSection.querySelector(".swiper-depoimentos-prev");
  if (botaoAnterior) {
    botaoAnterior.addEventListener("click", () => {
      clearInterval(progressoTimer);
      mostrarGrupo(grupoAtual > 0 ? grupoAtual - 1 : getTotalGrupos() - 1);
    });
  }

  swiper.on('breakpoint', () => {
    slidesPorGrupo = swiper.params.slidesPerView;
    totalSlides = depoimentosSection.querySelectorAll(".mySwiperDepoimentos .swiper-slide").length;
    criarBarras();
    mostrarGrupo(0);
  });

  window.addEventListener("resize", () => {
    atualizarNumeracao();
  });

  // Inicialização
  criarBarras();
  mostrarGrupo(0);
};

export default initializeDepoimentos;
